import { Box } from "@chakra-ui/react"
import { dateFnsLocalizer, type Event } from "react-big-calendar"
import { format, getDay, parse, startOfWeek } from "date-fns"
import { enUS } from "date-fns/locale/en-US"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { Calendar } from "react-big-calendar"

const locales = { "en-US": enUS }

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
})

export interface CalendarEvent extends Event {
  id?: string
  color?: string
}

interface CalendarViewProps {
  events: CalendarEvent[]
  onSelectEvent?: (event: CalendarEvent) => void
}

const SWIM_LEVEL_COLORS: Record<string, string> = {
  "Tot (Ages 3-4 years)": "#FED7D7",
  Bubble: "#BEE3F8",
  Kicker: "#C6F6D5",
  Star: "#FEFCBF",
  Roller: "#E9D8FD",
  Puller: "#FED7E2",
  Charger: "#B2F5EA",
  Challenge: "#FEEBC8",
  "Intermediate(was Pre-Competitive)": "#C4F1F9",
  "Advance (was Competitive)": "#FBD38D",
  "Delta (Level 9 - Level 12)": "#D6BCFA",
  "Gamma (Level 13 - Level 16)": "#FBB6CE",
}

function eventStyleGetter(event: CalendarEvent) {
  const bgColor = event.color || "#BEE3F8"
  return {
    style: {
      backgroundColor: bgColor,
      color: "#1A202C",
      borderRadius: "4px",
      border: "none",
      fontSize: "12px",
      padding: "2px 4px",
    },
  }
}

export function CalendarView({ events, onSelectEvent }: CalendarViewProps) {
  return (
    <Box h="600px" bg="white" borderRadius="md" borderWidth="1px" p={2}>
      <Calendar
        localizer={localizer}
        events={events}
        defaultView="week"
        views={["week", "day"]}
        min={new Date(2000, 0, 1, 6, 0)}
        max={new Date(2000, 0, 1, 21, 0)}
        onSelectEvent={onSelectEvent}
        eventPropGetter={eventStyleGetter}
        style={{ height: "100%" }}
      />
    </Box>
  )
}

export { SWIM_LEVEL_COLORS }

export default CalendarView
